/* @flow */
import React from 'react';
import UnauthenticatedView from 'auth/components/UnauthenticatedView.jsx';
import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Container from 'components/Container.jsx';
import AppDownloadImageLinks from 'components/AppDownloadImageLinks.jsx';
import Image from 'components/Image.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Text from 'components/Text.jsx';
import './styles/TymkThanksView.scss';

class TymkThanksView extends React.Component {
  render() {
    return (
      <UnauthenticatedView {...this.props}>
        <Container size="small" className="TymkThanksView">
          <Box>
            <BoxHeader
              className="TymkThanksView-header"
              title="Want to get even more out of Remind?">
              <Text className="TymkThanksView-subtext" color="thunder">
                Download the app on your phone or tablet!
              </Text>
            </BoxHeader>
            <BoxBody>
              <AppDownloadImageLinks className="TymkThanksView-downloadImages" />
              <Image src={require('assets/images/app-screenshot.jpg')} />
            </BoxBody>
          </Box>
        </Container>
      </UnauthenticatedView>
    );
  }
}

export default TymkThanksView;



// WEBPACK FOOTER //
// ./src/user/components/TymkThanksView.jsx